<div class="display-flex margin-top-1">
    <div class="justify-content-center">
        <img class="content-image" [src]="backgroundImage" />
    </div>
    <div class="justify-content-left">
        <h6 class="margin-top-0" [innerHtml]="content.longName || content.title"></h6>
    </div>
</div>

